"use client";import{useRef as r,useEffect as t,useCallback as e}from"react";const c=(// eslint-disable-next-line @typescript-eslint/no-explicit-any
c,n=500)=>{
// eslint-disable-next-line no-undef
const u=r(void 0),o=r(c);
// callback이 변경될 때마다 ref 업데이트
t((()=>{o.current=c}),[c]);const i=e(((...r)=>{u.current||(o.current(...r),u.current=setTimeout((()=>{u.current=void 0}),n))}),[n]);
// cleanup 함수
return t((()=>()=>{void 0!==u.current&&clearTimeout(u.current)}),[]),i};export{c as default};
